import axios from "axios";

export function getLecturerAvailabilityList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "LecturerAvailability/getlist", config);
}

// export function postVideo(data) {
//   const config = {
//     headers: { "Content-Type": "multipart/form-data" },
//   };
//   return axios.post(process.env.VUE_APP_API_URL + "Video/add", data, config);
// }

// export function updateVideo(data) {
//   return axios.put(process.env.VUE_APP_API_URL + "Video/update", data);
// }

// export function deleteVideo(videoId) {
//   const config = {
//     params: {
//       videoId: videoId,
//     },
//   };

//   return axios.delete(process.env.VUE_APP_API_URL + "Video/deleted", config);
// }
